export const CONSTANT = {
    DEFAULT_AVATAR: '/default-avatar.png',
    RPC_WLD: import.meta.env.VITE_RPC_WLD,
    TOKEN_WLD: import.meta.env.VITE_TOKEN_WLD,
    APP_ID: import.meta.env.VITE_APP_ID,
    WS_PRICE_URL: import.meta.env.VITE_WS_PRICE_URL,
    URL_HISTORY_HOLDSTATION: import.meta.env.VITE_URL_HISTORY_HOLDSTATION,
    WLD: import.meta.env.VITE_TOKEN_WLD,
    URL_SCAN: import.meta.env.VITE_URL_SCAN,
    WS_TRADE_URL: import.meta.env.VITE_WS_TRADE_URL,
    API_EARN_URL: import.meta.env.VITE_API_EARN_URL,
    API_EARN_URL_FUTURE: import.meta.env.VITE_API_EARN_URL_FUTURE,
    CONTRACT_REF: import.meta.env.VITE_CONTRACT_CLAIM_REF,
    CONTRACT_CLAIM_FREE_WLD: import.meta.env.VITE_CONTRACT_CLAIM_FREE_WLD,
    CONTRACT_CLAIM_AION: import.meta.env.VITE_CONTRACT_CLAIM_AION,
    CONTRACT_STOREFRONT: import.meta.env.VITE_CONTRACT_STOREFRONT,
    CONTRACT_STOREFRONT_STORAGE: import.meta.env
        .VITE_CONTRACT_STOREFRONT_STORAGE,
    AUTH_API_URL: import.meta.env.VITE_AUTH_API_URL,
};
